import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnSeeSales } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import ViewSalesModal from '@components/Modal/ViewSalesModal'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchSeeSales } from '@utils/fetchData'
import { debouncedSet } from '@utils/debounce'
import { http } from '@services/http'

const SeeSales = () => {
	const { t } = useTranslation()
	const location = useLocation()
	const formattedDate = getToday()

	const queryParams = window.location.search.split('cardCode=')[1]
	const cardCode =
		window.location.search.split('cardCode=')[1] ||
		localStorage.getItem('cardCode')

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'seeSales',
			currentPage,
			cardCode,
			docNum,
			startDate,
			endDate,
		],
		queryFn: fetchSeeSales,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const fetchOneSale = async (docEntry, api) => {
		if (!docEntry) return
		try {
			let url = `${api}?docNum=${docEntry}`
			const { data } = await http.get(url)
			setSelectedRowData(data.data[0])
		} catch (error) {
			console.log(error)
		}
	}

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		if (record?.docType === 'Sales Order') {
			fetchOneSale(record?.docNum, 'api/sales/sotuv-buyurtmasi')
			console.log('Sales Order')
		} else if (record?.docType === 'Delivery Note') {
			fetchOneSale(record?.docNum, 'api/sales/ortib-yuborilgan')
			console.log('Delivery Note')
		} else if (record?.docType === 'Invoice') {
			fetchOneSale(record?.docNum, 'api/sales/tugallangan-sotuvlar')
			console.log('Invoice')
		}
		setIsModalVisible(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}

	const columns = columnSeeSales(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		handleSlpNameChange,
	)
	return (
		<Layout>
			<Header
				title={'act-sverka'}
				currentPage={currentPage + 1}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
				rowKey={(row) => {
					return `${row.docEntry}-${row.docType}`
				}}
			/>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				ship={false}
				incoming={false}
			/>
		</Layout>
	)
}

export default SeeSales
